import styled from 'styled-components';
import { color, font } from '../../../../../assets/common';
export const Title = styled.p`
  color: #3f3c4c;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 39px;
`;

export const Label = styled.span`
  text-transform: none;
  font-size: 12px;
  font-weight: 500;
  color: #525252;
`;

export const No = styled.span`
  color: #8896a7;
  font-size: 14px;
  font-weight: 700;
`;

export const Text = styled.span`
  color: #2d2b39;
  font-size: 14px;
  font-weight: 500;
`;

export const Cell = styled.div`
  text-align: center;
`;

export const TableManagement = styled.div`
  width: 100%;
  margin-top: 20px;

  input[type='checkbox'] {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  input[type='checkbox']:checked {
    accent-color: #00a19c;
    padding: 2px;
  }
  .ant-table-thead {
    .ant-table-cell {
      color: #8896a7;

      &::before {
        content: none !important;
      }
    }
  }

  .ant-pagination {
    position: relative;
  }
  .ant-pagination-total-text {
    position: absolute;
    left: 0;
  }

  .ant-pagination-prev,
  .ant-pagination-next {
    button {
      border: none;
      background-color: transparent;
    }
  }

  .ant-pagination-item-active {
    background: #00a19c;
    color: #fff;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #00a19c;
    border-color: #00a19c;
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: #fff;
    border-color: #00a19c;

    &:after {
      background-color: #00a19c;
    }
  }

  .ant-table-tbody > tr.ant-table-row-selected > td {
    background-color: white;
  }

  .ant-table-tbody .ant-table-cell {
    height: 74px;
    white-space: pre-wrap;
  }

  .ant-table-thead > tr > th {
    background: white;
  }

  .ant-table-thead .ant-table-cell {
    color: #ffffff;
    font-size: 14px;
    font-weight: 700;
    background-color: #00a19c;
  }

  table tr td.ant-table-selection-column {
    padding-top: 40px;
    padding-bottom: 40px;
    padding-left: 23px;
    padding-right: 50px;
  }

  table tr th.ant-table-selection-column {
    padding-right: 50px;
    padding-left: 23px;
    border-left: 1px solid #d3dee8;
  }

  table tr td.ant-table-selection-column {
    border-left: 1px solid #d3dee8;
  }

  .ant-table-thead > tr > th {
    border-bottom: 1px solid #d3dee8;
    border-top: 1px solid #d3dee8;
  }

  .ant-table-tbody > tr > td:first-child {
    border-left: 1px solid #d3dee8;
  }

  .ant-table-tbody > tr > td:last-child {
    border-right: 1px solid #d3dee8;
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #d3dee8;
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner {
    border-color: #d9d9d9;
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner:after {
    background-color: white;
  }

  .pagination-custom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
  }

  .ant-pagination-item-active {
    border-color: ${color.teal};
  }

  .ant-pagination-item:hover {
    border-color: ${color.teal};
  }

  .avatar {
    text-align: right;
    img {
      width: 50px;
      height: 50px;
      boder-radius: 50%;
    }
  }
`;

export const AiNoAgenda = styled.div`
  text-align: center;
  padding: 88px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: white;
  border: 1px solid #d3dee8;
  border-radius: 6px;
`;
export const AiNoAgendaTitle = styled.span`
  font-family: ${font.inter};
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #3f3c4c;
  margin-bottom: 5px;
`;
export const AiNoAgendaDesc = styled.span`
  color: #9f9eae;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  text-transform: none;
  max-width: 300px;
`;
export const AiImg = styled.img`
  max-width: 105px;
`;
